import { apiCallAdmin } from "../../services/api-service.js";

export const getOrgLogoApi = async () => {
  try {
    const response = await apiCallAdmin("get", "get_org_image");
    return response.data;
  } catch (err) {
    console.error("Error fetching category:", err);
  }
};

export const getProfileDetailsApi = async () => {
  try {
    const response = await apiCallAdmin("get", "basicprofile");
    return response;
  } catch (err) {
    console.error("Error fetching options:", err);
    return null;
  }
};

export const reportAnIssueApi = async (data) => {
  try {
    return await apiCallAdmin("post", "report_issue", data);
  } catch (err) {
    console.error("Error fetching category:", err);
  }
};

export const getReportIssueTypeApi = async () => {
  try {
    const response = await apiCallAdmin("get", "get_issue_type");
    return response.data;
  } catch (err) {
    console.error("Error fetching category:", err);
  }
};

export const getFAQListApi = async () => {
  try {
    const response = await apiCallAdmin("get", "help?application=Vendor");
    return response.data;
  } catch (err) {
    console.error("Error fetching category:", err);
  }
};

export const updateProfileImageApi = async (data) => {
  try {
    return await apiCallAdmin("post", "user/image_update", data);
  } catch (err) {
    console.error("Error fetching category:", err);
  }
};

export const getOrgListApi = async (application_id) => {
  try {
    return await apiCallAdmin("get", `get_enrolled_orgs?application_id=${application_id}`);
  } catch (err) {
    console.error("Error fetching category:", err);
  }
};

const isHttpsOnly = process.env.REACT_APP_HTTPS_ONLY === "true";

export const getSwitchAccountApi = async (id) => {
  try {
    const endpoint = isHttpsOnly ? `switch_org_http_only/${id}` : `switch_org/${id}`;
    return await apiCallAdmin("get", endpoint);
  } catch (err) {
    console.error("Error switching account:", err);
  }
};

